// import "./App.css";
// import "./i18n";
// import DrawerApp from "./components/DrawerApp";
// import Login from "./screens/login.screen";
// import { useStateContext } from "./context/ContextProvider";
// import ResetPassword from "./screens/ResetPassword";
// import DailyPopup from "./components/Reminder";
// import { CustomThemeProvider } from "./context/ThemeContext";
// import PatientsEarlyAppointmentCheckReminder from "./components/PatientsEarlyAppointmentCheckReminder";
// import CreateIssueScreen from "./screens/create_issue.screen.jsx";
// import ServiceIssues from "./screens/ServiceIssues/ServiceIssues";

// export default function App() {
//   const { token, user } = useStateContext();

//   const currentPath = window.location.pathname;

//   if (currentPath === "/reset-password") {
//     return (
//       <CustomThemeProvider>
//         <ResetPassword />
//       </CustomThemeProvider>
//     );
//   }

//   if (!token) {
//     return (
//       <CustomThemeProvider>
//         <Login />
//       </CustomThemeProvider>
//     );
//   }

//   return (
//     <CustomThemeProvider>
//       <div className="App">
//         {(user?.user_role === "ADMIN" || user?.user_role === "STAFF") && (
//           <>
//             <DailyPopup />
//             <PatientsEarlyAppointmentCheckReminder />
//           </>
//         )}
//         <DrawerApp />
//       </div>
//     </CustomThemeProvider>
//   );
// }



import "./App.css";
import "./i18n";
import DrawerApp from "./components/DrawerApp";
import Login from "./screens/login.screen";
import { useStateContext } from "./context/ContextProvider";
import ResetPassword from "./screens/ResetPassword";
import DailyPopup from "./components/Reminder";
import { CustomThemeProvider } from "./context/ThemeContext";
import PatientsEarlyAppointmentCheckReminder from "./components/PatientsEarlyAppointmentCheckReminder";

export default function App() {
  const { token, user } = useStateContext();
  const currentPath = window.location.pathname;

  if (currentPath === "/reset-password") {
    return (
      <CustomThemeProvider>
        <ResetPassword />
      </CustomThemeProvider>
    );
  }

  if (!token) {
    return (
      <CustomThemeProvider>
        <Login />
      </CustomThemeProvider>
    );
  }

  return (
    <CustomThemeProvider>
      <div className="App">
        {(user?.user_role === "ADMIN" || user?.user_role === "STAFF") && (
          <>
            <DailyPopup />
            <PatientsEarlyAppointmentCheckReminder />
          </>
        )}
        <DrawerApp />
      </div>
    </CustomThemeProvider>
  );
}